module.exports = __webpack_public_path__ + "static/media/how_it_works_icon3.a3ee479d.png";